<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>

import { useAppStore } from "@/stores/app";

export default {
    name: "app",
    head: {
        title() {
            if (!this.$route.meta?.title) {
                return;
            }
            return {
                inner: this.$i18n.t(this.$route.meta?.title),
                separator: "-"
            };
        }
    },
    watch: {
        $route() {
            this.$emit("updateHead");
        }
    },
    created() {
        window["j2eSetiOS"] = this.setiOSApp;
        window["j2eCanUpload"] = mediaType => {
            const appStore = useAppStore();
            return appStore.allowedMediaType(mediaType);
        };
        window["j2eAddMedia"] = data => {
            const appStore = useAppStore();
            appStore.addMedia(data);
        };
    },
    methods: {
        setiOSApp() {
            const appStore = useAppStore();
            appStore.setIOSApp();
        }
    },
};
</script>

<style>
.svg-sprite {
    visibility: hidden;
    width: 0;
    height: 0;
}
</style>
